<div class="pop-up-card-container mat-elevation-z2 tab-container chamfer">
    <!-- ############################################# -->
    <!-- #############| WIDGET CONTENT |############## -->
    <!-- ############################################# -->
    <div class='widget-content'>
        <mat-tab-group color='accent' [selectedIndex]="selectedTab" (selectedIndexChange)="selectedTab = $event">
            <mat-tab *ngFor="let tab of tabs;let idx = index;" [label]="tab.text">
                <ng-template [appTabHolder]="tab.component" [data]='tab.data' [fullscreen]='isFullScreen' [tabIndex]="idx"></ng-template>
            </mat-tab>
        </mat-tab-group>

        <div class="toolbar-actions">
            <button mat-icon-button (click)="openInFullScreen()" *ngIf='!isFullScreen'>
                <span class="material-icons">
                    fullscreen
                </span>
            </button>

            <button mat-icon-button matDialogClose *ngIf='isFullScreen'>
                <span class="material-icons">
                    close
                </span>
            </button>
        </div>
    </div>

    <div class='card-footer'>
        <ng-content select="[card-footer]">
        </ng-content>
    </div>
</div>